// extracted by mini-css-extract-plugin
export var breadcrumb = "_19-2";
export var breadcrumbArrow = "_19-3";
export var breadcrumbs = "_19-0";
export var link = "_19-4";
export var small = "_19-1";